import { memoize } from "lodash";

import { FormBox } from "../../../../../../../utils/forms/components/FormBoxes";
import * as ACCOUNTING_CONSTS from "./AccountingConfiguration.constants";
import buildFormGridFields from "../../../../../../../utils/forms/builders/build-form-grid-fields";
import buildSchemaCompliantDefinition from "../../../../../../../utils/forms/builders/build-schema-compliant-definition";

const LABELS = {
    0: "sas",
    1: "s2s",
    2: "tito"
};
export const accountingConfigBox = ({
    system,
    expiration,
    provider,
    voucher,
    accountingSchema,
    hasPrefixCode,
    accepted_coins,
    accepted_bills,
    hasTITOSystem
}): FormBox[] => {
    let formDefinition = {};
    const accountingFormDefinition =
        ACCOUNTING_CONSTS.ACCOUNTING_FORM_DEFINITION(
            system,
            expiration,
            provider,
            voucher,
            accountingSchema.properties.system &&
                accountingSchema.properties.system.enum
                ? accountingSchema.properties.system.enum
                : [],
            hasPrefixCode,
            accepted_coins,
            accepted_bills,
            hasTITOSystem
        );

    // If no system is selected, pass empty schema
    let systemDefinitions =
        {...accountingSchema.definitions[`$${LABELS[system]}`]} || {};

    if(expiration == 0 || expiration == 1 || expiration == null && (Object.keys(systemDefinitions).length > 0 && systemDefinitions.hasOwnProperty('required'))) {
        // Add expiration_time as required
        systemDefinitions.required.push('expiration_time')
    } else if((Object.keys(systemDefinitions).length > 0 && systemDefinitions.hasOwnProperty('required')) && systemDefinitions.required.includes('expiration_time')) {
        systemDefinitions.required = systemDefinitions.required.filter(v => v !== 'expiration_time')
    }

    let unconditionalFields = [ACCOUNTING_CONSTS.SCHEMA_NAMES.SYSTEM];
    if(accountingSchema.properties.hasOwnProperty(ACCOUNTING_CONSTS.SCHEMA_NAMES.ACCEPTED_COINS) && accountingSchema.properties.hasOwnProperty(ACCOUNTING_CONSTS.SCHEMA_NAMES.ACCEPTED_BILLS)){
        unconditionalFields = [ACCOUNTING_CONSTS.SCHEMA_NAMES.SYSTEM, ACCOUNTING_CONSTS.SCHEMA_NAMES.COIN_BILL_ACCEPTOR_GROUP, ACCOUNTING_CONSTS.SCHEMA_NAMES.ACCEPTED_COINS, ACCOUNTING_CONSTS.SCHEMA_NAMES.ACCEPTED_BILLS];
    }
    formDefinition = buildSchemaCompliantDefinition(
        systemDefinitions,
        accountingFormDefinition,
        unconditionalFields
    );

    const schemaToUse = accountingSchema.definitions[`$${LABELS[system]}`]
        ? buildComplexSchema(accountingSchema, systemDefinitions)
        : accountingSchema;

    return [
        {
            fields: buildFormGridFields(schemaToUse, formDefinition),
            columnClass: "col-12"
        }
    ];
};

const buildComplexSchema = (baseSchema, systemDefinitions) => {
    let newSchema = { ...baseSchema };
    newSchema.required = newSchema.required.concat(systemDefinitions.required);
    newSchema.properties = {
        ...newSchema.properties,
        ...systemDefinitions.properties
    };
    return newSchema;
};
